import DeliveryMethods from './DeliveryMethods';

export default DeliveryMethods;


// WEBPACK FOOTER //
// ./src/components/Query/DeliveryMethods/index.ts